<div class="modal-header">
    <h5 class="modal-title text-white" data-testid="result-modal-title">
        {{ success ? 'Message successfully sent.' : 'Could not send the message. Please try again.' }}
    </h5>
</div>
<div class="modal-body" data-testid="result-modal-body">
    <p class="text-muted small mb-0" data-testid="result-status-message">{{ statusMessage }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="close()" data-testid="result-close-btn">Close</button>
</div>
